/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 验证验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  captchaRequest: dictionary.CaptchaRequest,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/dictionary/captcha/verify`,
    data: captchaRequest,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
